import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { SetPointPage } from './set-point';

@NgModule({
  declarations: [
    SetPointPage,
  ],
  imports: [
    IonicPageModule.forChild(SetPointPage),
  ],
  exports:
  [
    SetPointPage
  ]
})
export class SetPointPageModule {}



// WEBPACK FOOTER //
// ./src/pages/set-point/set-point.module.ts